/**
 * Selector to get the user tokens.
 * @param {Immutable.Map} state - The full application state
 * @returns {Immutable.Map} - The user tokens
 */
export const tokensSelector = (state) => {
    return state.getIn(['user', 'tokens']);
};

/**
 * Selector to get the control payload.
 * @param {Immutable.Map} state - The full application state
 * @returns {Immutable.Map} - The control payload
 */
export const controlPayloadSelector = (state) => {
    return state.getIn(['user', 'journey', 'control']);
};

/**
 * Selector to get the control payload.
 * @param {Immutable.Map} state - The full application state
 * @returns {Immutable.Map} - The prefill payload
 */
export const prefillPayloadSelector = (state) => {
    return state.getIn(['vertical', 'quote', 'form', 'helpers', 'prefill']);
};

/**
 * Selector to get the transaction payload
 * @param {Immutable.Map} state - The full application state
 * @returns {Immutable.Map} - The transaction payload
 */
export const transactionPayloadSelector = (state) => {
    return state.getIn(['user', 'journey', 'transaction']);
};

/**
 * Selector to get the offers payload
 * @param {Immutable.Map} state - The full application state
 * @returns {Immutable.Map} - The offers payload
 */
export const offerEventSelector = (state) => {
    return state.getIn(['user', 'journey', 'offers']);
};

/**
 * Selector to get the isAnonPrefillOrphan payload.
 * @param {Immutable.Map} state - The full application state
 * @returns {Immutable.Map} - The isAnonPrefillOrphan payload
 */
export const anonPrefillOrphanPayloadSelector = (state) => {
    return state.getIn(['vertical', 'quote', 'form', 'isAnonPrefillOrphan']);
};
